export const MODEL_OPTIONS = [
  { value: "gpt-4.1", label: "GPT-4.1" },
  { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
  { value: "gpt-5", label: "GPT-5" },
  { value: "gpt-5-mini", label: "GPT-5 Mini" },
  { value: "gpt-5.4", label: "GPT-5.4" },
  { value: "gpt-5.4-mini", label: "GPT-5.4 Mini" },
  { value: "gpt-5.4-nano", label: "GPT-5.4 Nano" },
  { value: "gpt-5.5", label: "GPT-5.5" },
  { value: "gpt-5.6", label: "GPT-5.6" },
  { value: "gemini-3.5-flash", label: "Gemini 3.5 Flash" },
  { value: "gemini-3.1-pro-preview", label: "Gemini 3.1 Pro Preview" },
  { value: "gemini-3.1-flash-lite", label: "Gemini 3.1 Flash-Lite" },
  { value: "claude-opus-5", label: "Claude Opus 5" },
  { value: "claude-opus-4-8", label: "Claude Opus 4.8" },
  { value: "claude-opus-4-7", label: "Claude Opus 4.7" },
  { value: "claude-sonnet-5", label: "Claude Sonnet 5" },
  { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" },
  { value: "claude-haiku-4-5", label: "Claude Haiku 4.5" },
  { value: "sonar", label: "Sonar" },
  { value: "sonar-pro", label: "Sonar Pro" },
  { value: "sonar-deep-research", label: "Sonar Deep Research" }
] as const;

export type TModelType = (typeof MODEL_OPTIONS)[number]["value"];

export const MODEL_CHOOSER_OPTIONS: { value: TModelType; label: string }[] = [
  { value: "gpt-5.5", label: "GPT-5.5" },
  { value: "gpt-5.6", label: "GPT-5.6" },
  { value: "gemini-3.1-pro-preview", label: "Gemini 3.1 Pro" },
  { value: "claude-opus-4-8", label: "Opus 4.8" },
  { value: "claude-sonnet-5", label: "Sonnet 5" }
];

export const DEFAULT_CHOOSER_MODEL: TModelType = "gemini-3.1-pro-preview";

export const isChooserModel = (model: string | null | undefined): model is TModelType =>
  MODEL_CHOOSER_OPTIONS.some((m) => m.value === model);
